export default __webpack_public_path__ + "static/media/DSC_0533.98fb39ef.webp";